import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { MatSnackBar } from "@angular/material";
import { environment } from '../../environments/environment';

import { MaratonService } from '../services/maraton.service';
import { Maraton } from '../models/maraton';
import { MaratonEditorComponent } from '../maraton-editor/maraton-editor.component';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
@Component({
  selector: 'app-maraton-list',
  templateUrl: './maraton-list.component.html',
  styleUrls: ['./maraton-list.component.css']
})
export class MaratonListComponent implements OnInit {



  models: Maraton[];
  Url = environment.imgUrl;

  constructor(private modelService: MaratonService, public dialog: MatDialog, private snackBar: MatSnackBar) {
    this.models = [];
  }

  ngOnInit() {
    this.getAll();
  }

  openEditor(id) {

    const dialogConfig = new MatDialogConfig();

    dialogConfig.width = '600px';
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      id: id
    };

    const dialogRef = this.dialog.open(MaratonEditorComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(
      data => {
        this.getAll();

      }
    );
  }

  delete(id) {

    const dialogConfig = new MatDialogConfig();

    dialogConfig.width = '300px';

    const dialogRef = this.dialog.open(ConfirmDialogComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(
      data => {
        if (data == true) {
          this.modelService.delete(id).subscribe(
            val => {
              this.getAll();
              this.snackBar.open('Registro Eliminado', '', {
                duration: 2000,
              });
            });
        }
      }
    );

  }

  getAll() {

    let filter = {
    }

    this.modelService.getFilter(filter).subscribe(val => {
      this.models = val;

    },
      error => {
        console.log(error);
        console.log(<any>error);
      });

  }

  destacado(id, destacado) {

    let change = {
      id: id,
      destacado: destacado
    }
    this.modelService.destacado(change, id).subscribe(
      val => {
        if (val.status == true) {
          this.getAll();
          this.snackBar.open(val.message, '', {
            duration: 2000,
          });
        }
        else {
          this.snackBar.open(val.message, '', {
            duration: 2000,
            panelClass: ['red-snackbar']
          });
        }

      },
      error => {
        console.log(<any>error);
        this.snackBar.open('Intente de nuevo, ocurrio un error', '', {
          duration: 3000,
          panelClass: ['red-snackbar']
        });
      });
  }
}
